import { IViolation } from 'app/model/base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { SelfHostedIntegrationRuntime } from '../integrationRuntime/selfhosted.integrationRuntime';
import { sanitizeAndFormatString } from 'app/shared/utils/string.util';
import { validateIRVersion } from 'app/shared/utils/version.check.util';
import {
    Dataset,
    datasetValidators,
    IValidationContext,
    Metamodel,
    validateLinkedServicePermission
} from 'shell-models-lib';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';
import { DatasetRegistryService } from 'app/registries/dataset/dataset-registry.service';

datasetValidators.linkedServiceValidator = async (
    dataset: Dataset,
    linkedService: LinkedService,
    context: IValidationContext
): Promise<IViolation[] | undefined> => {
    const result: IViolation[] = [];
    if (dataset.isV2) {
        if (
            linkedService &&
            linkedService.integrationRuntime != null &&
            linkedService.integrationRuntime instanceof SelfHostedIntegrationRuntime
        ) {
            const ir = linkedService.integrationRuntime;
            const dsConfig = (
                await getServiceInstance<DatasetRegistryService>(context.contextData, 'DatasetRegistryService')
            ).getDatasetConfiguration(Metamodel.modelOf(dataset).name);
            const minRequiredIRVersion = dsConfig.supportIrVersion;
            if (
                minRequiredIRVersion &&
                !(await validateIRVersion(linkedService.integrationRuntime, minRequiredIRVersion, 10, context)) &&
                linkedService.integrationRuntime.version
            ) {
                result.push({
                    context: dataset,
                    message: () =>
                        sanitizeAndFormatString(
                            stringResources.Error_IRLowVersionForV2DatasetPrefix,
                            ir.version,
                            ir.name,
                            minRequiredIRVersion
                        ) +
                        stringResources.Error_IRUpgradeLink +
                        stringResources.Error_IRLowVersionSuffix,
                    doNotAutomaticallyCorrect: true
                });
            }
        }
    }
    if (linkedService) {
        result.push(...validateLinkedServicePermission(linkedService, context));
    }
    return result;
};

export { Dataset };
